module.exports = __webpack_public_path__ + "img/ledger-live-setting-step-twelve.59ff273e.png";